// A step's screen as a link: CourageMFG screens open in the app, Business Central pages and reports open in BC. Both
// open in a new tab, so a walk-through (or the map being edited) stays where it is.
import { Link } from "react-router-dom";
import type { Step } from "@couragemfg/api/processes-model";
import { SYSTEM_LABEL } from "@couragemfg/api/processes-model";
import { bcReportUrl, bcUrl } from "../config";
import { screenTarget } from "./screens";

type S = Pick<Step, "system" | "screen" | "type">;
const hrefOf = (s: S) => {
  const t = screenTarget(s);
  if (!t) return null;
  return t.kind === "app" ? { app: t.to } : { bc: t.kind === "bc" ? bcUrl(t.page) : bcReportUrl(t.report) };
};

/** A row that opens the step's screen: the system, the screen, and Open. Nothing when the screen doesn't link. */
export function OpenScreen({ s }: { s: S }) {
  const h = s.type === "end" ? null : hrefOf(s);
  if (!h) return null;
  const inner = <><span className={`sys ${s.system}`}><i className={`pmap-sw-${s.system}`} />{s.system === "bc" ? "Business Central" : "CourageMFG"}</span><span className="nm">{s.screen}</span><span className="go">Open <span aria-hidden="true">↗</span></span></>;
  const title = `Open ${s.screen}${s.system === "bc" ? " in Business Central" : ""} in a new tab`;
  return h.app
    ? <Link className="pmap-open" to={h.app} target="_blank" rel="noreferrer" title={title} aria-label={title}>{inner}</Link>
    : <a className="pmap-open" href={h.bc} target="_blank" rel="noopener noreferrer" title={title} aria-label={title}>{inner}</a>;
}

/** "BC · Sales Order" with the screen as a link when it links. */
export function ScreenText({ s }: { s: S }) {
  if (s.type === "end") return null;
  const sys = SYSTEM_LABEL[s.system] ?? "Manual";
  if (!s.screen) return <>{sys}</>;
  const h = hrefOf(s);
  const title = `Open ${s.screen}${s.system === "bc" ? " in Business Central" : ""} in a new tab`;
  return <>{sys} · {h?.app ? <Link to={h.app} target="_blank" rel="noreferrer" title={title} onClick={(e) => e.stopPropagation()}>{s.screen}</Link>
    : h?.bc ? <a href={h.bc} target="_blank" rel="noopener noreferrer" title={title} onClick={(e) => e.stopPropagation()}>{s.screen}</a> : s.screen}</>;
}
